/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';

export default {
    saveDPA(payload) {
        return HttpService.put(environment.API_DPA_POLICY, payload);
    },
    searchDPA(params) {
        return HttpService.get(environment.API_DPA_POLICY, {
            params,
        });
    },
    getDPADetail(policyId) {
        return HttpService.get(environment.API_DPA_POLICY + `/${policyId}`);
    },
    getPublishedVersion(id) {
        return HttpService.get(
            environment.API_DPA_POLICY + `/publish-version/` + id
        );
    },
    getDPADetailPublic(policyId) {
        return HttpServiceNoToken.get(
            environment.API_DPA_POLICY_PUBLIC + `/${policyId}`
        );
    },
    //History
    getHistoriesDPA(params) {
        return HttpService.get(environment.API_DPA_POLICY + `/history`, {
            params,
        });
    },
    getHistoryDetail(params) {
        return HttpService.get(environment.API_DPA_POLICY + `/history/detail`, {
            params,
        });
    },
    delete(policyId) {
        return HttpService.delete(environment.API_DPA_POLICY + `/${policyId}`);
    },
    rename(payload) {
        return HttpService.put(environment.API_DPA_POLICY + `/rename`, payload);
    },
};
